// extracted by mini-css-extract-plugin
module.exports = {"main":"dialog-page_main__1pEvH"};